import keyMirror from '../helpers/keymirror';

const actionTypes = keyMirror({
  GET_VOLUME_HISTORY: null,
});

export default actionTypes;
